// 本地环境配置
export default {
	env: 'development',
	mock: false,
	title: '开发',
  imgUrl: 'http://218.195.237.164',
	baseUrl: '', // 项目地址
	baseApi: '/', // 本地api请求地址,注意：如果你使用了代理，请设置成'/'
	APPID: 'wxb2b90c3586b41f7d',
	APPSECRET: '',
	$cdn: ''
}
